const Vue = window.Vue

Vue.component('Ts24MobileNavigation', () => import('./app/components/pageDesign/MobileNavigation.vue'))
